import React, { useState } from 'react';

import { API } from 'constants';
import client from '../../../../services/library-api';

import { useSwrRequestKeysToMutateFromContext } from '../../../../hooks/useSwrRequestKeysToMutateFromContext';

import { mutateDataAfterDeletingItem } from '../../../../helpers/swrMutateUtils';
import { mergeTwoArraysRemovingDuplicates } from '../../../../helpers/mergeTwoArraysRemovingDuplicates';

import { defaultErrorMessage } from '../../../../constants/errorMessages';

import ConfirmDeletionModalPattern from '../../../../design-system/ConfirmDeletionModalPattern/ConfirmDeletionModalPattern';

const DeletePlaybookModal = ({
    id,
    name,
    requestKeysToMutate: _requestKeysToMutate,
    onDeleteSuccess,
    onClose,
}) => {
    const [errorAlert, setErrorAlert] = useState(null);
    const [isLoading, setIsLoading] = useState(false);

    const {
        requestKeysToMutate: { playbooks: requestKeysToMutateFromContext },
    } = useSwrRequestKeysToMutateFromContext();

    const handleDeletePlaybook = async () => {
        try {
            setIsLoading(true);

            await client.delete(`${API.ROUTES.library.playbook}${id}/`);

            const requestKeysToMutate = mergeTwoArraysRemovingDuplicates(
                _requestKeysToMutate,
                requestKeysToMutateFromContext
            );
            mutateDataAfterDeletingItem({ requestKeysToMutate, id });

            onDeleteSuccess && onDeleteSuccess();

            onClose();
        } catch (e) {
            setIsLoading(false);
            setErrorAlert({ message: defaultErrorMessage, statusCode: e.response?.status });
        }
    };

    return (
        <ConfirmDeletionModalPattern
            title="Delete Playbook?"
            handleDelete={handleDeletePlaybook}
            onClose={onClose}
            isLoading={isLoading}
            confirmationTextStart="You are about to delete"
            confirmationTextEnd="are you sure you’d like to continue? This will delete any prompts and scenarios connected to the playbook."
            entityName={`${name},`}
            variant="secondary"
            errorAlert={errorAlert}
            setErrorAlert={setErrorAlert}
            buttonsSize="md"
        />
    );
};

export default DeletePlaybookModal;
